import React from 'react';
import ProvisaoDevedoresDuvidososService from '../../../../lib/api/provisaoDevedoresDuvidosos/provisaoDevedoresDuvidososService';
import TemplateParametro from '../shared/templateParametros/templateParametros';

class ProvisaoDevedoresDuvidosos extends React.Component<{}, {}> 
{
    constructor(props: any) 
    {
        super(props);
        this.state = {};
    }

    baixarExcelParametrosPDDGerador()
    {
        return ProvisaoDevedoresDuvidososService.obterExcel()
    }

    enviarParametrosEventGrid() 
    {
        return ProvisaoDevedoresDuvidososService.enviarParametrosAoEventGrid();
    }

    render() 
    {
        return (
            <TemplateParametro
                enviarParametrosEventGrid={this.enviarParametrosEventGrid}
                baixarExcelParametros={this.baixarExcelParametrosPDDGerador}
                enviarExcelParametros={ProvisaoDevedoresDuvidososService.enviarExcelParametros}
                deletarExcelParametros={ProvisaoDevedoresDuvidososService.deletarExcelParametros}
                nomeDoArquivo='Parametro PDD Gerador'
            ></TemplateParametro>
        );
    }
}

export default ProvisaoDevedoresDuvidosos